import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Icon from '../../components/AppIcon';
import ProfileSection from './components/ProfileSection';
import SubscriptionSection from './components/SubscriptionSection';
import NotificationSection from './components/NotificationSection';
import SecuritySection from './components/SecuritySection';
import ApiAccessSection from './components/ApiAccessSection';

const AccountSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const breadcrumbItems = [
    { label: 'Dashboard', path: '/crane-search-dashboard' },
    { label: 'Account Settings' }
  ];

  const tabs = [
    {
      id: 'profile',
      label: 'Profile',
      icon: 'User',
      component: ProfileSection
    },
    {
      id: 'subscription',
      label: 'Subscription',
      icon: 'CreditCard',
      component: SubscriptionSection
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: 'Bell',
      component: NotificationSection
    },
    {
      id: 'security',
      label: 'Security',
      icon: 'Shield',
      component: SecuritySection
    },
    {
      id: 'api',
      label: 'API Access',
      icon: 'Key',
      component: ApiAccessSection
    }
  ];

  const ActiveComponent = tabs?.find(tab => tab?.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="px-6 py-8">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="mb-8">
            <Breadcrumbs items={breadcrumbItems} className="mb-4" />
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-text-primary">Account Settings</h1>
                <p className="text-text-secondary mt-2">
                  Manage your profile, subscription, and account preferences
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Sidebar Navigation */}
            <div className="lg:col-span-1">
              <div className="bg-card rounded-lg border border-border p-4 sticky top-24">
                <nav className="space-y-2">
                  {tabs?.map((tab) => (
                    <button
                      key={tab?.id}
                      onClick={() => setActiveTab(tab?.id)}
                      className={`w-full flex items-center space-x-3 px-3 py-2 text-sm font-medium rounded-md transition-smooth ${
                        activeTab === tab?.id
                          ? 'bg-primary text-primary-foreground'
                          : 'text-text-secondary hover:text-primary hover:bg-muted'
                      }`}
                    >
                      <Icon name={tab?.icon} size={16} />
                      <span>{tab?.label}</span>
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            {/* Main Content */}
            <div className="lg:col-span-3">
              {ActiveComponent && <ActiveComponent />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;